import { Alert, Flex } from "antd"

interface NotDataWarningProps {
  date: string
  doMessage?: string
}

const NotDataWarning: React.FC<NotDataWarningProps> = ({ date, doMessage }) => {
  return (
    <Flex justify="flex-end" align="flex-start">
      <Alert
        message={`No data has been received since ${date}. ${doMessage ? doMessage : "If the issue persists, please contact the development team."}`}
        type="warning"
        showIcon={false}
      />
    </Flex>
  )
}

export default NotDataWarning
